<div class="change-password-wrapper">

  <div class="header flex-between-center">
    <i class="fal fa-lock"></i>
    <p class="m-0 font-bold">Enter new password</p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="close()"></i>
    </span>
  </div>

  <div class="change-password-card">
    <div class="change-password-row p-3">
      <app-input type="password" placeholder="New password" theme="light" [isInvalid]="errors.newPassword"
        [errorMessage]="errors.newPassword" [value]="data.newPassword" [hasShowPasswordIcon]="true"
        [hasBorderBottomOnActive]="false" [floatingLabel]="true" (appChange)="handleChange('newPassword', $event)"
        (appFocus)="handleFocus('newPassword')" (appBlur)="handleBlur('newPassword')"></app-input>
    </div>

    <div class="change-password-row p-3">
      <app-input type="password" placeholder="Confirm password" theme="light" styleClassInput="font-gray"
        [isInvalid]="errors.confirmPassword" [hasShowPasswordIcon]="true" [errorMessage]="errors.confirmPassword"
        [value]="data.confirmPassword" [hasBorderBottomOnActive]="false" [floatingLabel]="true"
        (appChange)="handleChange('confirmPassword', $event)" (appFocus)="handleFocus('confirmPassword')"
        (appBlur)="handleBlur('confirmPassword')">
      </app-input>
    </div>

    <div class="row m-0 p-3 mt-2 mb-2 change-password-validations">
      <ul>
        <li>
          Your new password must meet this criteria:
        </li>
        <li *ngFor="let rule of validationRules" [ngClass]="{ valid: rule.valid, invalid: !rule.valid }">
          <span *ngIf="rule.valid">✔</span>
          <span *ngIf="!rule.valid">✘</span>
          {{ rule.message }}
        </li>
      </ul>
    </div>
  </div>

  <div class="footer flex-end-center mt-4 pl-8p pt-4 b-top-gray-85">
    <button class="btn btn-border btn-100 mr-2" (click)="close()">
      Cancel
    </button>
    <button (click)="changePassword()" [disabled]="isProcessing || !isFormValid()"
      [ngClass]="{'not-allowed': !isFormValid()}" class="btn btn-primary btn-submit btn-100">
      <span *ngIf="!isProcessing">Save</span>
      <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
    </button>
  </div>

</div>